import { useRecoilValueLoadable } from 'recoil';
export const useIsServiceLoading = ({ serviceState, }) => {
    const responseLoadable = useRecoilValueLoadable(serviceState.responseRaw);
    return responseLoadable.state === 'loading';
};
export default useIsServiceLoading;
//# sourceMappingURL=use-is-service-loading.js.map